/* eslint-disable */ 
import i18n from "i18next";
/* eslint-disable */ 
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import {
  format as formatDate,
  formatRelative,
  formatDistance,
  isDate,
} from "date-fns";
import { enUS, enAU } from "date-fns/locale"; // import all locales we need
import { English } from "./languages/English";
import { Australian } from "./languages/Australian";
import { Spanish } from "./languages/Spanish";
import { Italian } from "./languages/Italian";

const locales = [enUS, enAU]; // used to look up the required local

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: "enUS",
    detection: {
      // Order and from where user language should be detected
      order: ['localStorage', 'cookie', 'navigator'],

      // Keys or params to lookup language from
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: 'i18next',

      // Cache user language on its updated in new verison - Ankit
      caches: ['localStorage', 'cookie'],
      // Optional expire and domain for cookies
      // cookieMinutes: 10080,
      // cookieDomain: window.location.hostname,
    },
    interpolation: {
      escapeValue: false,
      format: (value, format, lng) => {
        if (isDate(value)) {
          const locale = locales.find((obj) => obj.code === lng);

          if (format === "short") return formatDate(value, "P", { locale });
          if (format === "long") return formatDate(value, "PPPP", { locale });
          if (format === "relative")
            return formatRelative(value, new Date(), { locale });
          if (format === "ago")
            return formatDistance(value, new Date(), {
              locale,
              addSuffix: true,
            });

          return formatDate(value, format, { locale });
        }
        return value;
      },
    },
    resources: {
      enUS: English,
      enAU: Australian,
      es: Spanish,
      it: Italian,
    },
  });

export default i18n;
